import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchRestaurantFooter } from "../../actions/footerActions";
import "./css/Footer.css";

function Footer() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const footerData = useSelector((state) => state.footer?.data || {});

  const { restaurantId, tableId } = useParams();

  useEffect(() => {
    if (restaurantId) {
      dispatch(fetchRestaurantFooter(restaurantId)).catch(() => {});
    }
  }, [dispatch, restaurantId]);

  const restaurantName = footerData.restaurant_name || "Restaurant";


  const currentYear = new Date().getFullYear();

  const goHome = () => {
    navigate(
      `/${restaurantId}/table/${tableId}`
    );
  };

  const scrollToSection = (sectionId) => {
    const element =
      document.getElementById(sectionId);

    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <footer
      className="theme8-footer"
      id="theme8-contact"
    >

      {/* =================================================
          TOP FOOTER
      ================================================= */}

      <div className="theme8-footer-main">

        {/* BRAND */}

        <div className="theme8-footer-brand">

          <button
            type="button"
            className="theme8-footer-logo"
            onClick={goHome}
          >
            <span className="theme8-footer-logo-mark">
              {restaurantName.slice(0, 2).toUpperCase()}
            </span>

            <span>
              {restaurantName}
            </span>
          </button>

          <p>
            {footerData.description || ""}
          </p>

          <div className="theme8-footer-accent"></div>

        </div>


        {/* QUICK LINKS */}

        <div className="theme8-footer-column">

          <h3>Explore</h3>

          <button onClick={goHome}>
            Home
          </button>

          <button
            onClick={() =>
              scrollToSection("theme8-story")
            }
          >
            About Us
          </button>

          <button
            onClick={() =>
              scrollToSection("theme8-menu")
            }
          >
            Our Menu
          </button>

          <button
            onClick={() =>
              scrollToSection("theme8-gallery")
            }
          >
            Gallery
          </button>

        </div>


        {/* CONTACT — backend data, original Theme 8 classes */}
        <div className="theme8-footer-column">
          <h3>Contact</h3>
          {footerData.address && <p>{footerData.address}</p>}
          {footerData.phone && <a href={`tel:${footerData.phone}`}>{footerData.phone}</a>}
          {footerData.email && <a href={`mailto:${footerData.email}`}>{footerData.email}</a>}
        </div>
        <div className="theme8-footer-column">
          <h3>Opening Hours</h3>
          <div className="theme8-footer-hours">
            {footerData.opening_hours && <p>{footerData.opening_hours}</p>}
          </div>
        </div>

      </div>


      {/* =================================================
          BOTTOM FOOTER
      ================================================= */}

      <div className="theme8-footer-bottom">

        <p>
          © {currentYear} {restaurantName}.
          All rights reserved.
        </p>

        <div className="theme8-footer-bottom-links">
          <span>Food images are for presentation purposes only. Actual items may vary.</span>
        </div>
        <div className="theme8-footer-social">
          {/^https?:\/\//i.test((footerData.instagram_url || "").trim()) && <a href={footerData.instagram_url} target="_blank" rel="noopener noreferrer">IG</a>}
          {/^https?:\/\//i.test((footerData.facebook_url || "").trim()) && <a href={footerData.facebook_url} target="_blank" rel="noopener noreferrer">FB</a>}
          {/^https?:\/\//i.test((footerData.youtube_url || "").trim()) && <a href={footerData.youtube_url} target="_blank" rel="noopener noreferrer">YT</a>}
          {/^https?:\/\//i.test((footerData.whatsapp_url || "").trim()) && <a href={footerData.whatsapp_url.trim()} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">WA</a>}
        </div>

      </div>

    </footer>
  );
}

export default Footer;